// extracted by mini-css-extract-plugin
module.exports = {"column":"Card_column__3SfbY","card":"Card_card__2IT-K","image":"Card_image__30ice"};